import { Trans, useTranslation } from 'next-i18next';
import React, { FC } from 'react';

import { departmentPagesData } from '@/components/DepartmentPageLayout/departmentPagesData';
import { Icons } from '@/components/shared/Icons';
import { DepartmentPageSlug } from '@/types';

interface IDepartmentPageProps {
  slug: DepartmentPageSlug;
}

export const DepartmentPageLayout: FC<IDepartmentPageProps> = ({ slug }) => {
  const { t } = useTranslation();
  const { withExpositionsInfo, infoCards } = departmentPagesData[slug];

  return (
    <div>
      <div className="mb-8">
        <div className="flex">
          <h4 className="mr-4 w-full max-w-[120px] text-base font-bold md:max-w-[270px] md:text-lg">
            {t('department.direction-title')}
          </h4>
          <p className="w-full self-end">
            <Trans i18nKey={`department.${slug}.direction-text`} />
          </p>
        </div>
        <div className="mt-6 flex ">
          <h4 className="mr-4 w-full max-w-[120px] text-base font-bold md:max-w-[270px] md:text-lg">
            {t('department.territory-title')}
          </h4>
          <p className="w-full self-end">{t(`department.${slug}.territory-text`)}</p>
        </div>
      </div>
      <div className="mb-7">
        <h4 className="mb-7 text-base font-bold md:text-lg">{t('department.info-cards-title')}</h4>
        <div className="grid grid-cols-2 gap-x-3 gap-y-6 md:grid-cols-3">
          {infoCards.map(({ iconName, titleKey, textKey }) => (
            <div
              key={iconName}
              className="border-[rgba(36, 126, 128, 0.1)] flex h-[250px] flex-col items-center rounded-lg border bg-white px-4 pt-6 md:h-[295px]"
            >
              <div className="mb-5">{Icons({ name: iconName })}</div>
              <h4 className="text-xl font-bold md:text-[32px]">{t(`department.${slug}.${titleKey}`)}</h4>
              <p className="m-auto text-center text-base font-bold md:text-[18px]">
                {t(`department.${slug}.${textKey}`)}
              </p>
            </div>
          ))}
        </div>
      </div>
      <div className="mb-8">
        {withExpositionsInfo && (
          <div className="flex">
            <h4 className="mr-4 w-full max-w-[120px] text-base font-bold md:max-w-[310px] md:text-lg">
              {t('department.expositions-title')}
            </h4>
            <p className="w-full self-end">
              <Trans i18nKey={`department.${slug}.expositions-text`} />
            </p>
          </div>
        )}

        <div className="mt-6 flex">
          <h4 className="mr-4 w-full max-w-[120px] text-base font-bold md:max-w-[310px] md:text-lg">
            {t('department.location-title')}
          </h4>
          <p className="w-full self-end">{t(`department.${slug}.location-text`)}</p>
        </div>
      </div>
    </div>
  );
};
